import { render, staticRenderFns } from "./ApfSchoolBusServiceText.vue?vue&type=template&id=34f2f67e&scoped=true"
import script from "./ApfSchoolBusServiceText.vue?vue&type=script&lang=js"
export * from "./ApfSchoolBusServiceText.vue?vue&type=script&lang=js"
import style0 from "./ApfSchoolBusServiceText.vue?vue&type=style&index=0&id=34f2f67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f2f67e",
  null
  
)

export default component.exports